import React from "react";
import { connect } from "react-redux";
import CarFinanceCdpBanner from "./component";
import { bindActionCreators } from "redux";
import { startPreApprovalOnFly } from "../pre-approval-on-fly-modal/actions";

//add redux state to props
const mapStateToProps = ({
    preApprovalLoan: {
        financeData: {
            user: {
                firstName
            } = {},
            loanType: {
                isPurposeBusiness
            } = {}
        } = {},
        maxLoanAmount,
        preApproved
    } = {},
    abExperiment: {
        preApprovalOnFlyDesktop
    } = {}
}) => ({
    preApproved,
    maxLoanAmount,
    firstName,
    isPurposeBusiness,
    preApprovalOnFlyDesktop
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    startPreApprovalOnFlyConnect: startPreApprovalOnFly
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CarFinanceCdpBanner);
